import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/nb"; // load on demand
import { checkNested, getPageUrl } from "#scripts/general_functions";
import { show404 } from "#scripts/_404";
import $ from "jquery";
import language from "#scripts/translation";

export const getCalendar = (client, obj, callback) => {
	const id = obj.id || "";
	const number = obj.number;
	const category = obj.category || window.serverdata.configMeta.aim.calendar.localid;

	// https://sspkalender.prokom.no/api/kalender?Categories=&SearchText=&DateFrom=&DateTo=&Municipalities=&Kunde=kongsbergregionen&Id=19839&ItemDate=&WeekDays=&List=&Count=&Distributor=

	const munic = window.serverdata.configMeta.aim.calendar.municipalities || "";
	const gc = $.getJSON(
		`https://sspkalender.prokom.no/api/tidspunkt?Categories=${category}&SearchText=&DateFrom=&DateTo=&Municipalities=${munic}&Kunde=${window.serverdata.configMeta.aim.calendar.group}&Id=${id}&ItemDate=&WeekDays=&List=&Count=${number}&Distributor=`,
	).done((cal) => {
		callback(cal);
	});
	return gc;
};

export const getCalendarItem = (client, obj, callback) => {
	const listMode = window.serverdata.configMeta.aim.calendar?.listMode;
	const munic = window.serverdata.configMeta.aim.calendar.municipalities || "";
	const gc = $.getJSON(
		`https://sspkalender.prokom.no/api/kalender?Categories=&SearchText=&DateFrom=&DateTo=&Municipalities=${munic}&Kunde=${window.serverdata.configMeta.aim.calendar.group
		}&Id=${obj.id.split("_")[0]}&ItemDate=&WeekDays=&List=${listMode ?? "compact"}&Count=&Distributor=`,
	).done((cal) => {
		callback(cal);
	});
	return gc;
};

export const cleanCalendardObject = (cal, number) => {
	const activities = [];
	let cAct = 0;
	if (cal.MonthWithEvents) {
		if (checkNested(cal, "MonthWithEvents", "0", "DaysWithEvents", "0", "Events")) {
			$.each(cal.MonthWithEvents, (monthNr, monthObj) => {
				$.each(monthObj.DaysWithEvents, (dayNr, dayObj) => {
					$.each(dayObj.Events, (evenrNr, eventObj) => {
						cAct++;
						if (cAct <= number && eventObj.KalenderObjekt.KategoriIder.indexOf(window.serverdata.configMeta.aim.calendar.localid) > -1) {
							activities.push(eventObj);
						}
					});
				});
			});
		}
	}
	return { items: activities, length: cAct };
};

export const XsetCalendarList = (number, cal) => {
	dayjs.locale("nb"); // use Spanish locale globally
	const elements = [];
	let r = "";
	let cAct = 0;
	let newlink = "https://sspkalender.prokom.no/Account/Login?returnUrl=%2Fkalenderregistrering%2FCreate%2F1121";
	if (window.serverdata.configMeta.aim?.calendar?.clientid) {
		newlink = `https://sspkalender.prokom.no/Account/Login?returnUrl=%2Fkalenderregistrering%2FCreate%2F${window.serverdata.configMeta.aim?.calendar?.clientid}`;
	}

	const filtered = cleanCalendardObject(cal, number);
	const activities = filtered.items;
	cAct = filtered.length;

	const showLinks = (other = true) => {
		const extracalendars = window.serverdata.configMeta.aim.calendar.links;
		let otherCalLinks = [];
		let r = "";

		if (extracalendars) {
			for (const cal of extracalendars) {
				otherCalLinks.push(
					`<a href="${cal.url}" class="calendar__others__link" aria-label="${cal.title} (${language("NAV_OPEN_I_NEW")})" target=_blank><span class="material-icons-outlined notranslate">open_in_new</span> ${cal.title}</a>`,
				);
			}

			otherCalLinks = otherCalLinks.join("");
			r += `
                    <div class="calendar__others">
                        <div class="row">
                            ${other === true
					? `
                            <div class="col-2">
                                <span class="calendar__others__label">${language("ACTIVITY_OTHER")}</span>
                            </div>`
					: ""
				}
                            <div class="col">
                                ${otherCalLinks}
                            </div>
                        </div>
                    </div>
                `;
		}
		let calendarPossibleNew = true;

		if (checkNested(window.serverdata.configMeta.aim, "calendar", "possible_new")) {
			calendarPossibleNew = window.serverdata.configMeta.aim.calendar.possible_new;
		}

		if (cAct > number) {
			r += `
                        <div class="calendar__summary text-right"><a href="/event" class="calendar__seeall">${language("ACTIVITY_SEE_ALL")}</a> 
                        
                    `;
			if (calendarPossibleNew === true) {
				r += `
                    <a href="${newlink}" class="calendar__addnew">${language("ACTIVITY_ADD_NEW")}</a></div>`;
			}
		} else if (calendarPossibleNew === true) {
			r += `
                        <div class="calendar__summary"><a href="${newlink}" class="calendar__addnew">${language("ACTIVITY_ADD_NEW")}</a></div>
                    `;
		}
		return r;
	};

	if (activities.length > 0) {
		dayjs.extend(updateLocale);
		dayjs.updateLocale(
			"nb",
			{
				weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
				monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
			},
			"nn",
			{
				weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
				monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
			},
		);

		$.each(activities, (a, b) => {
			const from = dayjs(b.FraDato);
			let dayPart = from.date();
			let datePart = from.format("MMM");
			if (window.serverdata.configMeta.aim.calendar.displayMode === "1") {
				dayPart = from.format("ddd");
				datePart = from.format("DD. MMM");
			}
			elements.push(`
                <div class="calendar__item">
                    <div class="row row-eq-height calendar__item_grid with-image">
                        <div class="calendar__date-container">
                            <div class="cpcal__datespace h-100">
                                <span class="calendar__item__date">${dayPart}</span>
                                <span class="calendar__item__month">${datePart}</span>
                            </div>
                        </div>
                        
                        <!--div class="calendar__image-container">
                          <div class="calendar__item__image" data-src="https://sspkalender.prokom.no/FileUploads/Rælingen kommune/Offisiell-apning-av-Ravinen-RLG-00539_59ea.JPG"><img src="https://sspkalender.prokom.no/FileUploads/Rælingen kommune/Offisiell-apning-av-Ravinen-RLG-00539_59ea.JPG"></div>
                        </div-->
                        <div class="calendar__info-container">
                            <div><a href="/event/${b.Id}" class="calendar__item__link">${b.Name}</a></div>
                            <div class="clearfix">
                              <span class="material-icons-outlined notranslate calendar__item__icon calendar__item__icon-place"></span> ${b.Lokasjon.Adresse}
                            </div>
                        </div>
                    </div>
                </div>
                `);
		});
		r = elements.join("");
		r += showLinks();
		return r;
	}
	if (window.serverdata.configMeta.aim.calendar.links) {
		return showLinks(false);
	}
	return `
            <div class="frontpage__eventsitem">
                <div class="row">
                    <div class="col-12">
                        ${language("ACTIVITY_NO_POSTS", newlink)}
                    </div>
                </div>
            </div>
            `;
};

export const showCalendarItem = () => {
	dayjs.locale("nb");
	const id = getPageUrl().contentid;
	let ret = "";

	if (id === "") window.location = "/eventlist";

	getCalendarItem(window.serverdata.configMeta.aim, { id }, (cal) => {
		const activity = cal;
		if (hasEventPassed(activity.KalenderObjekt.Tidspunkter)) {
			return show404();
		}
		if (activity?.KalenderObjekt) {
			$("#currentPageBreadcrumb").html(activity.Name);
			let intro = "";
			const cal = activity.KalenderObjekt;
			const address = cal?.Sted[0];
			const fulltime = formatMultipleTimes(cal?.Tidspunkter);
			let media;
			const allMedia = cal?.MedieFiler;
			const contact = cal?.Kontakter;

			if (cal.Intro) {
				intro = `<p class="calendar__event__intro">${cal.Intro}</p>`;
			}

			const images = [];
			if (allMedia.length > 1) {
				for (const item of allMedia) {
					const imageUrl = encodeURIComponent(item.LargeUrl);
					images.push(
						`<button data-src="https://res.cloudinary.com/ssp/image/fetch/g_auto,w_316,h_316,c_fill,f_auto/${imageUrl}" class="calendar__event__thumblink"><img src="https://res.cloudinary.com/ssp/image/fetch/g_auto,w_88,h_88,c_fill,f_auto/${imageUrl}" alt="${item.Description}"></button>`,
					);
				}
			}

			let image = false;
			if (allMedia[0]) {
				media = allMedia[0];
				const imageUrl = encodeURIComponent(media.LargeUrl);
				image = `<div class="main-image" id="mainImage"><img src="https://res.cloudinary.com/ssp/image/fetch/g_auto,w_316,h_316,c_fill,f_auto/${imageUrl}" alt="${media.Description
					}" class="calendar__event__image"></div><div class="text-left">${images.join("")}</div>`;
			}

			const getCategegories = (obj, categories) => {
				$.each(obj, (nr, cat) => {
					const catHidden = window.serverdata.configMeta.aim.calendar?.hiddenCategories?.includes(cat.Id) ?? false;
					if (cat?.UnderKategori?.length === 0 && cat.Id !== window.serverdata.configMeta.aim.calendar.localid && !catHidden && !cat.Navn.match(/hovedkategori|visning/gim)) {
						categories.push(`<a href="/eventlist?category=${cat.Id}" class="calendar__event__linkpill" data-categoryid="${cat.Id}">${cat.Navn}</a>`); // {name:cat.Navn, id : cat.Id}
					}
					if (!catHidden && cat?.UnderKategori) {
						getCategegories(cat.UnderKategori, categories);
					}
				});
			};

			let categories = [];

			getCategegories(cal.Kategorier, categories);
			const categoriesHtml = categories.join("");

			let contactinfo = "";
			let doContact = false;

			if (contact.length > 0 || cal.Eier) {
				const allContact = [];
				for (const person of contact) {
					allContact.push(setContact(person));
				}

				const allContactHtml = allContact.join("");
				doContact = true;

				let contactTitle = "";
				if (contact.length > 0) {
					contactTitle = `
                          <h2 class="calendar__event__h2">${language("ACTIVITY_CONTACT")}</h2>`;
				}

				let eier = "";
				if (cal.Eier) {
					eier = `<h2 class="calendar__event__h2">${language("ACTIVITY_ORG")}</h2>
                          <p class="calendar__more__mb">${wrapOnSlashes(cal.Eier)}</p>`;
				}

				contactinfo = `
                      <div class="calendar__more">
                          ${eier}
                          ${contactTitle}
                          ${allContactHtml}
                      </div>`;
				if (eier.trim() === "" && allContactHtml.trim() === "") {
					contactinfo = "";
				}
			}

			let addr = "";
			if (address.Name) {
				addr = `
                      <div class="col-1"><span class="material-icons-outlined notranslate">location_on</span></div>
                      <div class="col">
                          ${address.Name}<br/>
                          ${address.Adresse}, ${address.PostNr || ""} ${address.PostSted || ""} 
                          <a href="https://www.google.com/maps/search/${address.Adresse}, ${address.PostNr || ""} ${address.PostSted || ""
					}" class="calendar__item__maplink calendar__link">${language("ACTIVITY_SHOW_IN_MAP")}</a>
                      </div>
                      `;
			}

			let facility = "";
			if (cal.Fasilitetsgruppe) {
				if (cal.Fasilitetsgruppe[0]) {
					let facilityList = [];
					for (const item of cal.Fasilitetsgruppe[0].Fasiliteter) {
						let description = item.Beskrivelse !== null ? `: ${item.Beskrivelse}` : "";
						facilityList.push(`<p>${item.Navn}${description}</p>`);
					}
					facilityList = facilityList.join("");
					facility = `
                          <h2 class="calendar__event__h2">${cal.Fasilitetsgruppe[0].Navn}</h2>
                          <div class="calendar__event__categories">${facilityList}</div>
                      `;
				}
			}

			let price = "";
			if (cal.Prisliste) {
				if (cal.Prisliste[0]) {
					const prices = [];
					for (const item of cal.Prisliste) {
						if (item.Gratis) {
							prices.push(`${item.Tittel}`);
						} else {
							const beskrivelse = item.Beskrivelse ? `${item.Beskrivelse}: ` : "";
							const prisFra = item.PrisFra ? item.PrisFra : "";
							const prisTil = item.PrisTil ? ` - ${item.PrisTil}` : "";
							const prisGruppe = item.PrisGruppe ? `(${item.PrisGruppe})` : "";
							prices.push(`${beskrivelse} ${prisFra} ${prisTil} ${prisGruppe}`);
						}
					}
					const pricesJoined = prices.join("</br>");
					price = `<div>${prices.length > 1 ? "Priser:</br>" : "Pris:"} ${pricesJoined}</div>`;
				}
			}

			let attachements = "";
			if (cal.VedleggFiler) {
				if (cal.VedleggFiler[0]) {
					const attachementsList = [];
					for (const item of cal.VedleggFiler) {
						attachementsList.push(`<a href="${item.Url}" class="calendar__link">${item.Description ? item.Description : item.Url}</a>`);
					}
					attachements = attachementsList.join("</br>");
				}
			}

			ret = `
              <div class="calendar__event ${doContact ? "" : "calendar__event-mb"}">
                  <div class="row">
                      <div class="col-sm-4 order-1 offset-sm-2 text-center">
                          ${image || ""}
                      </div>
                      <div class="col-sm-6">
                          <h1 class="calendar__event__title">${cal.Name}</h1>
                          ${intro}
                          <div class="calendar__event__tap">
                              <div class="row mb-4">
                                      ${addr}
                              </div>
                              <div class="row mb-2">
                                  <div class="col-1"><span class="material-icons-outlined notranslate">schedule</span></div>
                                  <div class="col">${fulltime}</div>
                              </div>
                              ${attachements &&
				`
                                  <div class="row mb-2">
                                      <div class="col-1"><span class="material-icons-outlined notranslate">draft</span></div>
                                      <div class="col">${attachements}</div>
                                  </div>`
				}
                          </div>
                          <h2 class="calendar__event__h2">${language("ACTIVITY_DESCRIPTION")}</h2>
                          <div class="calendar__event__desc">
                              ${cal.Beskrivelse}
                              ${cal.LinkUtsalg ? `<p class="mt-5">Billetter: <a href='${cleanUrl(cal.LinkUtsalg)}' class="calendar__link">${cal.LinkUtsalg}</a></p>` : ""}
                              ${cal.Nettside ? `<p>Nettside: <a href='${cleanUrl(cal.Nettside)}' class="calendar__link">${cal.Nettside}</a></p>` : ""}
                              ${price}
                          </div>
                          ${facility}
                          ${categoriesHtml !== "" ? `
                              <h2 class="calendar__event__h2">${language("ACTIVITY_CATEGORY")}</h2>
                              <div class="calendar__event__categories">
                              ${categoriesHtml}
                              </div>`
					: ""
				}
                      </div>
                  </div>
              </div>
              <div class="row ">
                  <div class="col-sm-6 offset-sm-6">
                      ${contactinfo}
                  </div>
              </div>
          `;
		} else {
			ret = show404();
		}

		const currentBreadcrumb = document.getElementById("currentPageBreadcrumb");
		const breadcrumbItem = document.createElement("li");
		breadcrumbItem.classList.add("aim-breadcrumb-item");
		const breadcrumbItemLink = document.createElement("a");
		breadcrumbItemLink.href = "/kalender";
		breadcrumbItemLink.innerText = language("START_CALENDAR");
		breadcrumbItem.appendChild(breadcrumbItemLink);
		if (currentBreadcrumb) {
			currentBreadcrumb.parentNode.insertBefore(breadcrumbItem, currentBreadcrumb);
			currentBreadcrumb.innerText = document.title;
		}

		$(".calendar__event__container").html(ret);

		$(".calendar__event__thumblink").click(function () {
			const newUrl = $(this).data("src");
			$("#mainImage").html(`<img src="${newUrl}" />`);
		});
	});
};

export const showCustomCalendarItem = () => {
	dayjs.locale("nb");
	const id = getPageUrl().contentid;
	let ret = "";

	if (id === "") window.location = "/eventlist_custom";
	getCalendarItem(window.serverdata.configMeta.aim, { id }, (cal) => {
		const activity = cal;

		if (activity) {
			$("#currentPageBreadcrumb").html(activity.Name);
			let intro = "";
			const cal = activity.KalenderObjekt;
			const address = cal.Sted[0];
			const fulltime = formatMultipleTimes(cal.Tidspunkter);
			let media;
			const allMedia = cal.MedieFiler;
			const contact = cal.Kontakter;

			if (cal.Intro) {
				intro = `<p class="custom calendar__event__intro">${cal.Intro}</p>`;
			}

			let image = false;
			if (allMedia[0]) {
				media = allMedia[0];
				const imageUrl = encodeURIComponent(media.LargeUrl);
				image = `
                <div class="main-image" id="mainImage">
                  <img src="https://res.cloudinary.com/ssp/image/fetch/g_auto,w_945,h_370,c_fill,f_auto/${imageUrl}" alt="${media.Description}" class="custom calendar__event__image">
                </div>`;
			}

			const getCategegories = (obj, categories) => {
				$.each(obj, (nr, cat) => {
					const catHidden = window.serverdata.configMeta.aim.calendar?.hiddenCategories?.includes(cat.Id) ?? false;
					if (cat.UnderKategori.length === 0 && cat.Id !== window.serverdata.configMeta.aim.calendar.localid && !catHidden && !cat.Navn.match(/hovedkategori|visning/gim)) {
						categories.push(`<a href="/eventlist_custom?category=${cat.Id}" class="custom calendar__event__linkpill" data-categoryid="${cat.Id}">${cat.Navn}</a>`); // {name:cat.Navn, id : cat.Id}
					}
					if (!catHidden && cat?.UnderKategori) {
						getCategegories(cat.UnderKategori, categories);
					}
				});
			};

			let categories = [];

			getCategegories(cal.Kategorier, categories);
			const categoriesHtml = categories.join("");

			let contactinfo = "";
			let doContact = false;

			if (contact.length > 0 || cal.Eier) {
				const allContact = [];
				for (const person of contact) {
					allContact.push(setContact(person));
				}

				const allContactHtml = allContact.join("");
				doContact = true;

				let contactTitle = "";
				if (contact.length > 0) {
					contactTitle = `
                          <h2 class="custom calendar__event__h2">${language("ACTIVITY_CONTACT")}</h2>`;
				}

				let eier = "";
				if (cal.Eier) {
					eier = `<h2 class="custom calendar__event__h2">${language("ACTIVITY_ORG")}</h2>
                          <p class="calendar__more__mb">${cal.Eier}</p>`;
				}

				contactinfo = `
                      <div class="calendar__more">
                          ${eier}
                          ${contactTitle}
                          ${allContactHtml}
                      </div>`;
				if (eier.trim() === "" && allContactHtml.trim() === "") {
					contactinfo = "";
				}
			}

			let addr = "";
			if (address.Name) {
				addr = `
                      <div class="col-x"><span class="material-icons-outlined notranslate">location_on</span></div>
                      <div class="col pl-0">
                          ${address.Name}<br/>
                          ${address.Adresse ? `${address.Adresse}, ` : ""}${address.PostNr || ""} ${address.PostSted || ""} 
                          <a href="https://www.google.com/maps/search/${address.Adresse}, ${address.PostNr || ""} ${address.PostSted || ""
					}" class="calendar__item__maplink calendar__link">${language("ACTIVITY_SHOW_IN_MAP")}</a>
                      </div>
                      `;
			}

			let facility = "";
			if (cal.Fasilitetsgruppe) {
				if (cal.Fasilitetsgruppe[0]) {
					let facilityList = [];
					for (const item of cal.Fasilitetsgruppe[0].Fasiliteter) {
						let description = item.Beskrivelse !== null ? `: ${item.Beskrivelse}` : ""
						facilityList.push(`<p>${item.Navn}${description}</p>`);
					}
					facilityList = facilityList.join("");
					facility = `
                          <h2 class="custom calendar__event__h2">${cal.Fasilitetsgruppe[0].Navn}</h2>
                          <div class="custom calendar__event__categories">${facilityList}</div>
                      `;
				}
			}

			let price = "";
			if (cal.Prisliste) {
				if (cal.Prisliste[0]) {
					const prices = [];
					for (const item of cal.Prisliste) {
						if (item.Gratis) {
							prices.push(`${item.Tittel}`);
						} else {
							let description = item.Beskrivelse ? `${item.Beskrivelse}: ` : "";
							let priceFrom = item.PrisFra ? item.PrisFra : "";
							let priceTo = item.PrisTil ? ` - ${item.PrisTil}` : "";
							let priceGroup = item.PrisGruppe ? `(${item.PrisGruppe})` : "";

							prices.push(`${description}${priceFrom}${priceTo}${priceGroup}`);
						}
						/*
													Beskrivelse: "Barn - voksen"
														Gratis: false
														PrisFra: "200"
														PrisGruppe: null
														PrisTil: "400"
														Tittel: null
													*/
					}
					const pricesJoined = prices.join("</br>");
					price = `<div>${prices.length > 1 ? "Priser:</br>" : "Pris:"} ${pricesJoined}</div>`;
				}
			}

			let attachements = "";
			if (cal.VedleggFiler) {
				if (cal.VedleggFiler[0]) {
					const attachementsList = [];
					for (const item of cal.VedleggFiler) {
						attachementsList.push(`<a href="${item.Url}" class="calendar__link">${item.Description ? item.Description : item.Url}</a>`);
					}
					attachements = attachementsList.join("</br>");
				}
			}

			ret = `
              <div class="custom calendar__event ${doContact ? "" : "calendar__event-mb"}">
                  <div class="row justify-content-center">
                    <div class="col-md-10 col-12">
                          ${image || ""}
                    </div>
                    <div class="col-md-7 col-12">
                        <h1 class="custom calendar__event__title">${cal.Name}</h1>
                        ${intro}
                        <div class="custom calendar__event__tap container">
                            <div class="row mb-4">
                                    ${addr}
                            </div>
                            <div class="row mb-2">
                                <div class="col-x"><span class="material-icons-outlined notranslate">calendar_today</span></div>
                                <div class="col pl-0">${fulltime}</div>
                            </div>
                            ${attachements &&
				`
                                <div class="row mb-2">
                                    <div class="col-x"><span class="material-icons-outlined notranslate">draft</span></div>
                                    <div class="col pl-0">${attachements}</div>
                                </div>`
				}
                        </div>
                        <h2 class="custom calendar__event__h2">${language("ACTIVITY_DESCRIPTION")}</h2>
                        <div class="custom calendar__event__desc">
                            ${cal.Beskrivelse}
                            ${cal.LinkUtsalg ? `<p class="mt-5">Billetter: <a href='${cleanUrl(cal.LinkUtsalg)}' class="calendar__link">${cal.LinkUtsalg}</a></p>` : ""}
                            ${cal.Nettside ? `<p>Nettside: <a href='${cleanUrl(cal.Nettside)}' class="calendar__link">${cal.Nettside}</a></p>` : ""}
                            ${price}
                        </div>
                        ${facility}
                        ${categoriesHtml !== ""
					? `
                            <h2 class="custom calendar__event__h2">${language("ACTIVITY_CATEGORY")}</h2>
                            <div class="custom calendar__event__categories">
                            ${categoriesHtml}
                            </div>
                        `
					: ""
				}
                        <div class="col-md-9 col-12 p-0">
                          ${contactinfo}
                      </div>
                    </div>
                  </div>
              </div>
          `;
		} else {
			ret = show404();
		}

		$(".calendar__event__container").html(ret);

		$(".calendar__event__thumblink").click(function () {
			const newUrl = $(this).data("src");
			$("#mainImage").html(`<img src="${newUrl}" />`);
		});
	});
};

const setContact = (contact) => {
	let contactName = "";
	if (contact.Navn) {
		contactName = `
                          <p class="calendar__more__mb">${contact.Navn}</p>`;
	}

	let contactEmail = "";
	if (contact.Epost) {
		contactEmail = `
                          <p class="calendar__more__pb"><span class="material-icons-outlined notranslate">mail</span> <a href="mailto:${contact.Epost}" class="calendar__link">${contact.Epost}</a></p>`;
	}
	let contactPhone = "";
	if (contact.Telefon) {
		contactPhone = `
                          <p class="calendar__more__pb"><span class="material-icons-outlined notranslate">call</span> <a href="tel:${contact.Telefon}" class="calendar__link">${contact.Telefon}</a></p>`;
	}

	return `
                          ${contactName}
                          ${contactEmail}
                          ${contactPhone}`;
};

const formatMultipleTimes = (Tidspunkter) => {
	let allTimes = "";

	if (Tidspunkter === undefined || Tidspunkter === null) return allTimes;
	for (const tidspunkt of Tidspunkter) {

		let ukedager = "";
		if (tidspunkt.Repeterende && !tidspunkt.OverFlereDager) {
			ukedager = weekdays(tidspunkt.Ukedager);
		}
		const from = dayjs(tidspunkt.FraDato);
		const to = dayjs(tidspunkt.TilDato);
		let fulltime = from.format("DD MMM YYYY");
		if (fulltime !== to.format("DD MMM YYYY")) {
			fulltime += ` til ${to.format("DD MMM YYYY Kl. ")}`;
		}
		fulltime += ` ${from.format("HH:mm")}-${to.format("HH:mm")}${ukedager !== "" ? ukedager : ""}`;
		allTimes += `${fulltime}<br/>`;
	}
	return allTimes;
};

const hasEventPassed = (Tidspunkter) => {
	if (Tidspunkter === undefined || Tidspunkter === null) return allTimes;
	let lastEventTime = dayjs(new Date());
	for (const tidspunkt of Tidspunkter) {
		if (tidspunkt.TilDato > lastEventTime) {
			lastEventTime = dayjs(tidspunkt.TilDato);
		}
	}
};

const weekdays = (_days) => {
	if (_days === "" || _days === null) return "";
	const returnArray = [];
	const dayArray = language("DAYJS_WEEKDAY_FULL").split(",");
	const days = _days.split(" ").map((x) => +x);
	for (let day of days) {
		if (day === 7) {
			returnArray.push(dayArray[0]);
		}
		else {
			returnArray.push(dayArray[day]);
		}
	}

	return ` (${replaceLast(returnArray.join(", "), ", ", " og ")})`;
};

const replaceLast = (str, pattern, replacement) => {
	const match = typeof pattern === "string" ? pattern : (str.match(new RegExp(pattern.source, "g")) || []).slice(-1)[0];
	if (!match) return str;
	const last = str.lastIndexOf(match);
	return last !== -1 ? `${str.slice(0, last)}${replacement}${str.slice(last + match.length)}` : str;
};

function wrapOnSlashes (str) {
	return str.replace(/\//g, "/<wbr>");
}

const cleanUrl = (link) => {
	if (!link.match(/^http/)) {
		return `https://${link}`;
	}
	return link;
};
